module.exports = __webpack_public_path__ + "2-44.jpg?44d4c5ab5c2e7506fa7b99e69d82ac27";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-44.jpg
// module id = 121
// module chunks = 0